'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage from "./presto.-Edit-Group-Site-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_EditGroupSitePage$() {
}
export { $c_Lpresto_EditGroupSitePage$ as $c_Lpresto_EditGroupSitePage$ };
$p = $c_Lpresto_EditGroupSitePage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EditGroupSitePage$;
/** @constructor */
function $h_Lpresto_EditGroupSitePage$() {
}
export { $h_Lpresto_EditGroupSitePage$ as $h_Lpresto_EditGroupSitePage$ };
$h_Lpresto_EditGroupSitePage$.prototype = $p;
$p.l = (function() {
  return "EditGroupSitePage";
});
$p.cFs = (function(x$0) {
  return new $j_presto$002e$002dEdit$002dGroup$002dSite$002dPage.$c_Lpresto_EditGroupSitePage(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_EditGroupSitePage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EditGroupSitePage$, "presto.EditGroupSitePage$", ({
  I1: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_EditGroupSitePage$ as $d_Lpresto_EditGroupSitePage$ };
var $n_Lpresto_EditGroupSitePage$;
function $m_Lpresto_EditGroupSitePage$() {
  if ((!$n_Lpresto_EditGroupSitePage$)) {
    $n_Lpresto_EditGroupSitePage$ = new $c_Lpresto_EditGroupSitePage$();
  }
  return $n_Lpresto_EditGroupSitePage$;
}
export { $m_Lpresto_EditGroupSitePage$ as $m_Lpresto_EditGroupSitePage$ };
//# sourceMappingURL=presto.-Edit-Group-Site-Page$.js.map
